import React, { Fragment } from 'react'

/** Messsage caption component to display information about overnights selected on the date pickers. */
const OvernightStaysCaption = (props) => {
    return (
        <div id="overnight_stays_content">
            {props.caption}
        </div>
    )
}

export default OvernightStaysCaption